import api from "../../API/apiConfig";

// 1. Lấy danh sách Contacts
export const getContacts = async (filters = {}) => {
  const { pageNo = 0, pageSize = 10, property = "contactId", direction = "ASC", ...otherFilters } = filters;
  return await api.get(`/contacts`, {
    params: { 
      pageNo, 
      pageSize, 
      property, 
      direction,
      ...otherFilters
    },
  });
};

// 2. Thêm mới Contact
export const addContact = async (contactData) => {
  return await api.post(`/contacts/add`, contactData);
};

// 3. Xem chi tiết Contact
export const getContactDetail = async (id) => {
  return await api.get(`/contacts/detail/${id}`);
};

// 4. Cập nhật Contact
export const updateContact = async (id, contactData) => {
  return await api.put(`/contacts/update/${id}`, contactData);
};

// 5. Xóa Contact
export const deleteContact = async (id) => {
  return await api.delete(`/contacts/delete/${id}`);
};

// 6. Thêm Contact vào Campaign
export const addContactToCampaign = async (id) => {
  return await api.post(`/contacts/add-to-campaign/`);
};
// 7. Lấy tất cả contact 
export const getAllContacts = async() =>{
  return await api.get(`/contacts/list-all`);
}

// Task API for Contacts
export const createContactTask = async (taskData) => {
  return await api.post('tasks/add', taskData);
};

export const viewContactTasks = async (type, id) => {
  try {
    const response = await api.get(`/tasks/${type}/${id}`);
    console.log("API Response:", response); 
    return response;
  } catch (error) {
    console.error("Error in viewContactTasks:", error);
    throw error;
  }
};

export const updateContactTask = async (id, taskUpdateData) => {
  return await api.put(`tasks/update/${id}`, taskUpdateData);
};

export const deleteContactTask = async (id) => {
  return await api.delete(`tasks/delete/${id}`);
};

export const getContactTaskDetail = async (id) => {
  return await api.get(`tasks/detail/${id}`);
};

// Call API for Contacts
export const createContactLogCall = async (data) => {
  try {
    const response = await api.post('log_call/add', data);
    return response;
  } catch (error) {
    console.error('Error in createContactLogCall:', error);
    throw error;
  }
};

export const viewContactLogCalls = async (type, id) => {
  try {
    const response = await api.get(`log_call/list-type?logCallType=${type}&recordId=${id}`);
    return response;
  } catch (error) {
    console.error('Error in viewContactLogCalls:', error);
    throw error;
  }
};

export const updateContactLogCall = async (id, data) => {
  try {
    const response = await api.put(`log_call/update/${id}`, data);
    return response;
  } catch (error) {
    console.error('Error in updateContactLogCall:', error);
    throw error;
  }
};

export const deleteContactLogCall = async (id) => {
  try {
    const response = await api.delete(`log_call/delete/${id}`);
    return response;
  } catch (error) {
    console.error('Error in deleteContactLogCall:', error);
    throw error;
  }
};

export const getContactLogCallDetail = async (id) => {
  try {
    const response = await api.get(`log_call/detail/${id}`);
    return response;
  } catch (error) {
    console.error('Error in getContactLogCallDetail:', error);
    throw error;
  }
};

export const updateContactLogCallStatus = async (id, status) => {
  try {
    const response = await api.put(`log_call/update-status/${id}`, { status });
    return response;
  } catch (error) {
    console.error('Error in updateContactLogCallStatus:', error);
    throw error;
  }
};

export default {
  getContacts,
  addContact,
  getContactDetail,
  updateContact,
  deleteContact,
  addContactToCampaign,
  createContactTask,
  viewContactTasks,
  updateContactTask,
  deleteContactTask,
  getContactTaskDetail,
  createContactLogCall,
  viewContactLogCalls,
  updateContactLogCall,
  deleteContactLogCall,
  getContactLogCallDetail,
  updateContactLogCallStatus,
};

//Get Accessibility cho Contact
export const getAccessibilityForContact = async (id) => {
  return await api.get(`/contacts/accessibility/${id}`);
};

//Update Accessibility cho Contact
export const updateAccessibilityForContact = async (id, data) => {
  return await api.post(`/contacts/update-access/${id}`, data);
};

// Change Owner
export const changeOwner = async (contactIds, newOwnerUuid) => {
  return await api.put("/contacts/change-owner", { contactIds, newOwnerUuid });
};

